import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";

// assets
import LogoIcon from "src/assets/images/logo/logo-new.svg";

import styles from "./Logo.module.scss";
const cx = classNames.bind(styles);

const Logo = ({ wrapperClass }) => {
  return (
    <div className={cx("logo-root", wrapperClass)}>
      <Link to="/">
        <img src={LogoIcon} alt="..." />
      </Link>
    </div>
  );
};

export default Logo;
